import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=cd22ce6e&scoped=true"
import script from "./InputItem.vue?vue&type=script&lang=js"
export * from "./InputItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd22ce6e",
  null
  
)

export default component.exports